import React from 'react';
import { Container } from '../Container/Container';
import { BackgroundProps } from './Background.types';

export const Background = ({
  children,
  classNames,
  hasContainer,
}: BackgroundProps): JSX.Element => {
  return (
    <div className={classNames}>
      {hasContainer ? <Container isCentered>{children}</Container> : children}
    </div>
  );
};
